module.exports = __webpack_public_path__ + "static/media/lp_self_discovery.e16e5ada.jpg";